import React from 'react';
import MetersIndexPage from '../meters_index_page/MetersIndexPage';

export default function MetersAllIndexPage() {
	return <MetersIndexPage preAppliedFilters={{}} targetCollectionName="allMetersIndex" />;
}
